import React from 'react';
import { Link } from 'react-router-dom';

export default function ArabicFooter() {
  return (
    <footer dir="rtl" className="bg-slate-900 text-white">
      <div className="mx-auto grid max-w-6xl gap-10 border-b border-slate-700/70 px-4 py-14 md:grid-cols-2 lg:grid-cols-[1.2fr_0.8fr_0.9fr_0.9fr]">
        <div>
          <div className="mb-4 inline-flex items-center gap-3">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-sky-500 to-cyan-400 font-extrabold text-white">S</span>
            <h2 className="text-2xl font-bold">StartaWebb</h2>
          </div>
          <p className="max-w-md leading-8 text-slate-300">
            نتواصل مع صاحب الشركة بالعربية، ونبني موقعًا احترافيًا باللغة السويدية يساعد العميل على فهم الخدمات وطلب عرض سعر أو التواصل مباشرة.
          </p>
          <p className="mt-4 text-sm text-slate-400">Kristinehamn · نخدم الشركات في جميع أنحاء السويد.</p>
        </div>

        <div>
          <h3 className="mb-4 text-lg font-bold">روابط سريعة</h3>
          <ul className="space-y-3 text-slate-300">
            <li><Link to="/ar" className="hover:text-sky-300">الرئيسية العربية</Link></li>
            <li><Link to="/ar/priser" className="hover:text-sky-300">الأسعار وطريقة العمل</Link></li>
            <li><Link to="/ar/kontakt" className="hover:text-sky-300">أرسل طلبك</Link></li>
            <li><Link to="/portfolio" className="hover:text-sky-300">المشاريع (بالسويدية)</Link></li>
            <li><Link to="/" lang="sv" className="hover:text-sky-300">Svenska</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="mb-4 text-lg font-bold">مواقع حسب النشاط</h3>
          <ul className="space-y-3 text-slate-300">
            <li><Link to="/ar/hemsidor-for-smaforetag" className="font-semibold text-sky-300 hover:text-white">كل الأنشطة</Link></li>
            <li><Link to="/ar/hemsida-stadfirma" className="hover:text-sky-300">شركة تنظيف</Link></li>
            <li><Link to="/ar/hemsida-flyttfirma" className="hover:text-sky-300">شركة نقل</Link></li>
            <li><Link to="/ar/hemsida-hantverkare" className="hover:text-sky-300">حرفي وشركة بناء</Link></li>
            <li><Link to="/ar/hemsida-frisor-salong" className="hover:text-sky-300">حلاق وصالون</Link></li>
            <li><Link to="/ar/hemsida-restaurang" className="hover:text-sky-300">مطعم ومقهى</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="mb-4 text-lg font-bold">التواصل</h3>
          <div className="space-y-3 text-slate-300">
            <p><a href="mailto:info@startawebb.se" className="hover:text-sky-300">info@startawebb.se</a></p>
            <p><a href="tel:+46734877119" dir="ltr" className="inline-block hover:text-sky-300">073-487-71-19</a></p>
            <p><a href="https://wa.me/46734877119?text=%D9%85%D8%B1%D8%AD%D8%A8%D8%A7%20StartaWebb%D8%8C%20%D8%A3%D8%B1%D9%8A%D8%AF%20%D9%85%D9%88%D9%82%D8%B9%D9%8B%D8%A7%20%D9%84%D8%B4%D8%B1%D9%83%D8%AA%D9%8A%20%D9%81%D9%8A%20%D8%A7%D9%84%D8%B3%D9%88%D9%8A%D8%AF." target="_blank" rel="noopener noreferrer" className="hover:text-sky-300">واتساب بالعربية</a></p>
          </div>
          <Link to="/ar/kontakt" className="mt-5 inline-flex rounded-xl bg-sky-600 px-5 py-3 font-bold text-white transition hover:bg-sky-500">أرسل معلومات الشركة</Link>
        </div>
      </div>

      <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-4 py-6 text-xs text-slate-400 md:flex-row">
        <p>© {new Date().getFullYear()} StartaWebb.</p>
        <nav className="flex flex-wrap justify-center gap-4">
          <Link to="/integritetspolicy" className="hover:text-white">الخصوصية (بالسويدية)</Link>
          <Link to="/användarvillkor" className="hover:text-white">الشروط (بالسويدية)</Link>
          <Link to="/cookies-policy" className="hover:text-white">ملفات الارتباط</Link>
          <Link to="/ar/remove-personal-data" className="hover:text-white">حذف البيانات الشخصية</Link>
        </nav>
      </div>
    </footer>
  );
}
